import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
const Label = forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(({
  className,
  ...props
}, ref) => <label ref={ref} className={cn('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70', className)} {...props} data-id="element-430" />);
Label.displayName = 'Label';
export { Label };